[
  {
    "key": "material_01",
    "description": "material name",
    "fr": "Skintex",
    "en": "Skintex",
    "es": "Skintex",
    "de": "Skintex",
    "it": "Skintex",
    "e": ""
  },
  {
    "key": "Green",
    "description": "material name",
    "fr": "Cuir",
    "en": "Leather",
    "es": "Cuero",
    "de": "Leder",
    "it": "Pelle",
    "e": ""
  },
  {
    "key": "material_03",
    "description": "material name",
    "fr": "Cuir métalique",
    "en": "Metallic leather",
    "es": "Cuero métalico",
    "de": "Leder Metallic",
    "it": "Pelle metallizzata",
    "e": ""
  },
  {
    "key": "material_01",
    "description": "material name",
    "fr": "Skintex noir",
    "en": "Skintex black",
    "es": "Skintex negro",
    "de": "Skintex schwarz",
    "it": "Skintex nero",
    "e": "หนัง สีดำเงา"
  },
  {
    "key": "material_02",
    "description": "material name",
    "fr": "Skintex noir mat",
    "en": "Skintex matte black",
    "es": "Skintex negro mate",
    "de": "Skintex schwarz matt",
    "it": "Skintex nero opaco",
    "e": "หนัง สีดำด้าน"
  },
  {
    "key": "material_03",
    "description": "material name",
    "fr": "Skintex blanc",
    "en": "Skintex white",
    "es": "Skintex blanco",
    "de": "Skintex weiß",
    "it": "Skintex bianco",
    "e": "หนัง สีขาว"
  },
  {
    "key": "material_04",
    "description": "material name",
    "fr": "Skintex rouge",
    "en": "Skintex red",
    "es": "Skintex rojo",
    "de": "Skintex rot",
    "it": "Skintex rosso",
    "e": "หนัง สีแดง"
  },
  {
    "key": "material_05",
    "description": "material name",
    "fr": "Skintex bleu",
    "en": "Skintex blue",
    "es": "Skintex azul",
    "de": "Skintex blau",
    "it": "Skintex blu",
    "e": "หนัง สีน้ำเงิน"
  },
  {
    "key": "material_06",
    "description": "material name",
    "fr": "Skintex or",
    "en": "Skintex gold",
    "es": "Skintex oro",
    "de": "Skintex gold",
    "it": "Skintex oro",
    "e": "หนัง สีทอง"
  },
  {
    "key": "material_07",
    "description": "material name",
    "fr": "Skintex argent",
    "en": "Skintex silver",
    "es": "Skintex plata",
    "de": "Skintex silber",
    "it": "Skintex argento",
    "e": "หนัง สีเงิน"
  },
  {
    "key": "material_08",
    "description": "material name",
    "fr": "Skintex kaki mat",
    "en": "Skintex matte khaki",
    "es": "Skintex kaki mate",
    "de": "Skintex khaki matt",
    "it": "Skintex cachi opaco",
    "e": "หนัง เคลือบ สีกากี"
  },
  {
    "key": "material_09",
    "description": "material name",
    "fr": "Skintex bleu marine mat",
    "en": "Skintex matte navy blue",
    "es": "Skintex azul marino mate",
    "de": "Skintex amrineblau matt",
    "it": "Skintex blu navy opaco",
    "e": "หนัง  เคลือบ สีกรมท่า"
  },
  {
    "key": "material_10",
    "description": "material name",
    "fr": "Skintex jaune fluo",
    "en": "Skintex fluo yellow",
    "es": "Skintex amarillo fluo",
    "de": "Skintex gelb fluoreszierend",
    "it": "Skintex giallo fluo",
    "e": "หนัง สีเหลืองสะท้อนแสง"
  },
  {
    "key": "material_11",
    "description": "material name",
    "fr": "Skintex orange fluo",
    "en": "Skintex fluo orange",
    "es": "Skintex naranja fluo",
    "de": "Skintex orange fluoreszierend",
    "it": "Skintex arancione fluo",
    "e": "หนัง ส้มสะท้อนแสง"
  },
  {
    "key": "material_12",
    "description": "material name",
    "fr": "Skintex rose fluo",
    "en": "Skintex fluo pink",
    "es": "Skintex rosa fluo",
    "de": "Skintex rosa fluoreszierend",
    "it": "Skintex rosa fluo",
    "e": "หนัง สีชมพูสะท้อนแสง"
  },
  {
    "key": "material_13",
    "description": "material name",
    "fr": "Skintex gris",
    "en": "Skintex grey",
    "es": "Skintex gris",
    "de": "Skintex grau",
    "it": "Skintex grigio",
    "e": "หนัง สีเทา"
  },
  {
    "key": "material_14",
    "description": "material name",
    "fr": "Cuir noir",
    "en": "Leather black",
    "es": "Cuero negro",
    "de": "Leder schwarz",
    "it": "Pelle nero",
    "e": "หนังแท้ สีดำเงา"
  },
  {
    "key": "material_15",
    "description": "material name",
    "fr": "Cuir noir mat",
    "en": "Leather matte black",
    "es": "Cuero negro mate",
    "de": "Leder schwarz matt",
    "it": "Pelle nero opaco",
    "e": "หนังแท้ สีดำด้าน"
  },
  {
    "key": "material_16",
    "description": "material name",
    "fr": "Cuir blanc",
    "en": "Leather white",
    "es": "Cuero blanco",
    "de": "Leder weiß",
    "it": "Pelle bianco",
    "e": "หนังแท้ สีขาว"
  },
  {
    "key": "material_17",
    "description": "material name",
    "fr": "Cuir rouge",
    "en": "Leather red",
    "es": "Cuero rojo",
    "de": "Leder rot",
    "it": "Pelle rosso",
    "e": "หนังแท้ สีแดง"
  },
  {
    "key": "material_18",
    "description": "material name",
    "fr": "Cuir bleu",
    "en": "Leather blue",
    "es": "Cuero azul",
    "de": "Leder blau",
    "it": "Pelle blu",
    "e": "หนังแท้ สีน้ำเงิน"
  },
  {
    "key": "material_19",
    "description": "material name",
    "fr": "Cuir métalique doré",
    "en": "Metallic leather gold",
    "es": "Cuero metálico oro",
    "de": "Leder Metallic Gold",
    "it": "Pelle metallizzata oro",
    "e": "หนังแท้ ฟรอยด์ สีฟรอยด์ทอง"
  },
  {
    "key": "material_20",
    "description": "material name",
    "fr": "Cuir métalique argenté",
    "en": "Metallic leather silver",
    "es": "Cuero metálico plata",
    "de": "Leder Metallic Silber",
    "it": "Pelle metallizata argento",
    "e": "หนังแท้ ฟรอยด์ สีฟรอยด์เงิน"
  },
  {
    "key": "material_21",
    "description": "material name",
    "fr": "Cuir métalique bleu",
    "en": "Metallic leather blue",
    "es": "Cuero metálico azul",
    "de": "Leder Metallic Blau",
    "it": "Pelle metallizzata blu",
    "e": "หนังแท้ ฟรอยด์ สีฟรอยด์น้ำเงิน"
  },
  {
    "key": "material_22",
    "description": "material name",
    "fr": "Cuir métalique rouge",
    "en": "Metallic leather red",
    "es": "Cuero metálico rojo",
    "de": "Leder Metallic Rot",
    "it": "Pelle metallizzata rosso",
    "e": "หนังแท้ ฟรอยด์ สีฟรอยด์แดง"
  },
  {
    "key": "material_23",
    "description": "material name",
    "fr": "Cuir Khaki",
    "en": "Khaki Leather",
    "es": "",
    "de": "",
    "it": "",
    "e": "หนังแท้ สีกากี"
  },
  {
    "key": "material_24",
    "description": "material name",
    "fr": "Cuir Bleu marine",
    "en": "Navy blue Leather",
    "es": "",
    "de": "",
    "it": "",
    "e": "หนังแท้ สีกรมท่า"
  },
  {
    "key": "material_25",
    "description": "material name",
    "fr": "Cuir Jaune",
    "en": "Yellow Leather",
    "es": "",
    "de": "",
    "it": "",
    "e": "หนังแท้ สีเหลือง"
  },
  {
    "key": "material_26",
    "description": "material name",
    "fr": "Cuir Rose",
    "en": "Pink Leather",
    "es": "",
    "de": "",
    "it": "",
    "e": "หนังแท้ สีชมพู"
  },
  {
    "key": "material_27",
    "description": "material name",
    "fr": "Cuir Orange",
    "en": "Orange Leather",
    "es": "",
    "de": "",
    "it": "",
    "e": "หนังแท้ สีส้ม"
  },
  {
    "key": "color_01",
    "description": "color name",
    "fr": "Noir",
    "en": "Black",
    "es": "Negro",
    "de": "Schwarz",
    "it": "Nero",
    "e": "สีดำเงา"
  },
  {
    "key": "color_02",
    "description": "color name",
    "fr": "Noir mat",
    "en": "Matte black",
    "es": "Negro Mate",
    "de": "Schwarz matt",
    "it": "Nero opaco",
    "e": "สีดำด้าน"
  },
  {
    "key": "color_03",
    "description": "color name",
    "fr": "Blanc",
    "en": "White",
    "es": "Blanco",
    "de": "Weiß",
    "it": "Bianco",
    "e": "สีขาว"
  },
  {
    "key": "color_04",
    "description": "color name",
    "fr": "Gris",
    "en": "Grey",
    "es": "Gris",
    "de": "Grau",
    "it": "Grigio",
    "e": "สีเทา"
  },
  {
    "key": "color_05",
    "description": "color name",
    "fr": "Bleu",
    "en": "Blue",
    "es": "Azul",
    "de": "Blau",
    "it": "Blu",
    "e": "สีน้ำเงิน"
  },
  {
    "key": "color_06",
    "description": "color name",
    "fr": "Rouge",
    "en": "Red",
    "es": "Rojo",
    "de": "Rot",
    "it": "Rosso.",
    "e": "สีแดง"
  },
  {
    "key": "color_07",
    "description": "color name",
    "fr": "Jaune",
    "en": "Yellow",
    "es": "Amarillo",
    "de": "Gelb",
    "it": "Giallo",
    "e": "สีเหลือง"
  },
  {
    "key": "color_08",
    "description": "color name",
    "fr": "Orange",
    "en": "Orange",
    "es": "Naranja",
    "de": "Orange",
    "it": "Arancione",
    "e": "สีส้ม"
  },
  {
    "key": "color_09",
    "description": "color name",
    "fr": "Rose",
    "en": "Pink",
    "es": "Rosa",
    "de": "Rosa",
    "it": "Rosa",
    "e": "สีชมพู"
  },
  {
    "key": "color_10",
    "description": "color name",
    "fr": "Violet",
    "en": "Purple",
    "es": "Violeta",
    "de": "Lila",
    "it": "Viola",
    "e": "สีม่วง"
  },
  {
    "key": "color_11",
    "description": "color name",
    "fr": "Vert",
    "en": "Green",
    "es": "Verde",
    "de": "Grün",
    "it": "Verde",
    "e": "สีเขียว"
  },
  {
    "key": "color_12",
    "description": "color name",
    "fr": "Kaki",
    "en": "Khaki",
    "es": "Kaki",
    "de": "Khaki",
    "it": "Cachi",
    "e": "สีกากี"
  },
  {
    "key": "color_13",
    "description": "color name",
    "fr": "Bleu marine",
    "en": "Navy blue",
    "es": "Azul Marino",
    "de": "Marineblau",
    "it": "Blu navy",
    "e": "สีกรมท่า"
  },
  {
    "key": "color_14",
    "description": "color name",
    "fr": "Marron",
    "en": "Brown",
    "es": "Marrón",
    "de": "Braun",
    "it": "Marrone",
    "e": "สีน้ำตาล"
  },
  {
    "key": "color_15",
    "description": "color name",
    "fr": "OR",
    "en": "Gold",
    "es": "Oro",
    "de": "Gold",
    "it": "Oro",
    "e": "สีฟรอยด์ทอง"
  },
  {
    "key": "color_16",
    "description": "color name",
    "fr": "Argent",
    "en": "Silver",
    "es": "Plata",
    "de": "Silber",
    "it": "Argento",
    "e": "สีฟรอยด์เงิน"
  },
  {
    "key": "color_17",
    "description": "color name",
    "fr": "Jaune fluo",
    "en": "Fluo yellow",
    "es": "Amarillo Fluo",
    "de": "Gelb fluoreszierend",
    "it": "Giallo fluo",
    "e": "สีเหลืองสะท้อนแสง"
  },
  {
    "key": "color_18",
    "description": "color name",
    "fr": "Rose fluo",
    "en": "Fluo pink",
    "es": "Rosa Fluo",
    "de": "Rosa fluoreszierend",
    "it": "Rosa fluo",
    "e": "สีชมพูสะท้อนแสง"
  },
  {
    "key": "color_19",
    "description": "color name",
    "fr": "Orange fluo",
    "en": "Fluo orange",
    "es": "Naranja Fluo",
    "de": "Orange fluoreszierend",
    "it": "Arancione fluo",
    "e": "ส้มสะท้อนแสง"
  }
]